import { jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { IconBase } from "src/components/ui/IconBase";
export default memo(forwardRef(function IconSvgModalClose({
  className,
  "data-test-id": dataTest = "IconModalClose",
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(IconBase, { ...props, "data-test-id": dataTest, className, innerRef: ref, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx("path", { fill: "#757575", d: "M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z" }) }) });
}));
